import React from 'react';
import PropTypes from 'prop-types';
import adStates from './ad-states';

const getClassName = adState => {
    switch (adState) {
        case adStates.filled:
            return 'react-ad react-ad--loaded';
        case adStates.empty:
            return 'react-ad react-ad--empty';
        default:
            return 'react-ad';
    }
};

const AdComponent = ({
    adState,
    className,
    width,
    height,
    scale,
    children
}) => (
    <div
        className={`${getClassName(adState)} ${
            adState === adStates.filled ? className : ''
        }`}
        style={{
            width: width * scale,
            height: height * scale
        }}>
        {scale === 1 ? (
            <div>{children}</div>
        ) : (
            <div
                style={{
                    width: width,
                    height: height,
                    transform: `scale(${scale})`,
                    transformOrigin: 'left top'
                }}>
                {children}
            </div>
        )}
    </div>
);

AdComponent.propTypes = {
    adState: PropTypes.string.isRequired,
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    scale: PropTypes.number,
    children: PropTypes.node
};

AdComponent.defaultProps = {
    className: '',
    scale: 1
};

export default AdComponent;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/Areas/MyTradera/static/script/app/components/ads/ad-component.jsx